// import 'promise-polyfill';
// import 'isomorphic-fetch';

let NextInLine = require('./widget');

function paramsFromUrl() {
	let params = {};
	let hashes = location.search.slice(location.search.indexOf('?') + 1).split('&');

	hashes.forEach(hash => {
        let [key, val] = hash.split('=');
        params[key] = decodeURIComponent(val);
    })

	return params;
}

function init() {
	let params = paramsFromUrl();
	
	if(module.hot){
		NextInLine = require('./widget');
	}
	
	window.NextInLine = NextInLine;
	
	
	if(window.nsaiframe){
		const widget = document.querySelector('#widget');
		window.nextInLine = NextInLine.init({
			...params,
			demoMode: true,
			organizationID: params.organizationID,
			displayOrganizationName: true,
			cost: 60

		})
		window.nextInLine.render(widget);
	}
}

// // register ServiceWorker via OfflinePlugin, for prod only:
// if (process.env.NODE_ENV==='production') {
// 	require('./pwa');
// }

// in development, set up HMR:
if (module.hot) {
	//require('preact/devtools');   // turn this on if you want to enable React DevTools!
	module.hot.accept('./widget', () => requestAnimationFrame(init) );
}

function loadEventScripts() {
	const params =  paramsFromUrl();
	let baseURL = '';
	
	if (params.version){
		baseURL = `https://${params.version.replace('.', '')}.appspot.com`
	} else if(params.subdomain){
		baseURL = `https://${params.version.replace('.', '')}.nextinline.io`
	} else if(window.location.host.includes('localhost')){
		baseURL = 'http://localhost:4000'
	} else if(window.location.origin.includes('nextinline.io')){
		baseURL= window.location.origin.replace('minnow', 'shark').replace('otter', 'shark').replace('scheduling', 'shark').replace('www', 'shark')
	}else{
		baseURL= 'https://shark.nextinline.io'
	}

	if(params.organizationID && baseURL){
		let script = document.createElement('script');
		script.src = `${baseURL}/organizations/${params.organizationID}/events.js`;
		script.onload = () => {
			if (typeof onLoadSnippet === 'function') {
				onLoadSnippet();
			} else {
				console.error('onLoadSnippet is not defined');
			}
		};
		document.body.appendChild(script);
	}
}

loadEventScripts();
init();



// WEBPACK FOOTER //
// ./index.js